<template>
    <div class="main main-padding tab-data-details">
        <div class="top-area">
            <!--返回-->
            <div class="main-back">
                <div class="bank-back" v-on:click="gotoBack">
                    <img src="../../../../assets/images/back.png"/>
                    <p class="click-text">返回</p>
                </div>
            </div>
            <!--产品类型下拉框-->
            <div class="pro-download">
                <span>产品类型:</span>
                <Select v-model="proKey" style="width:200px" @on-change="onChange">
                    <Option v-for="item in proList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </div>
            <!--时间选择器-->
            <div class="time-select-picker">
                <div class="time-select">
                    <Row :gutter="10">
                        <date-select @updateDateTime="updateDateTime" ref="dateSelect"></date-select>
                    </Row>
                </div>
            </div>
        </div>
        <!--数据信息-->
        <card>
            <!--头部tab及搜索框-->
            <div class="card-header-area">
                <!--tab切换数据-->
                <div class="tab-data">
                    <Tabs type="card" @on-click="changeDataDetailsIndex" :value="params.teaName" v-if="proKey=='-1'">
                        <TabPane label="教师使用全部产品的场景详情" name="notAddTime"></TabPane>
                        <TabPane label="教师具体使用全部产品详情" name="isAddTime"></TabPane>
                        <!--<TabPane label="教师使用产品详情记录" name="detailRecord"></TabPane>-->
                    </Tabs>
                    <Tabs type="card" @on-click="changeDataDetailsIndex" :value="params.teaName" v-if="proKey=='1'">
                        <TabPane label="教师使用大屏的场景详情" name="notAddTime"></TabPane>
                        <TabPane label="教师具体使用大屏详情" name="isAddTime"></TabPane>
                        <!--<TabPane label="教师使用产品详情记录" name="detailRecord"></TabPane>-->
                    </Tabs>
                    <Tabs type="card" @on-click="changeDataDetailsIndex" :value="params.teaName" v-if="proKey=='2'">
                        <TabPane label="教师使用移动授课助手的场景详情" name="notAddTime"></TabPane>
                        <TabPane label="教师具体使用移动授课助手详情" name="isAddTime"></TabPane>
                        <!--<TabPane label="教师使用产品详情记录" name="detailRecord"></TabPane>-->
                    </Tabs>
                    <Tabs type="card" @on-click="changeDataDetailsIndex" :value="params.teaName" v-if="proKey=='3'">
                        <TabPane label="教师使用备课助手的场景详情" name="notAddTime"></TabPane>
                        <TabPane label="教师具体使用备课助手详情" name="isAddTime"></TabPane>
                        <!--<TabPane label="教师使用产品详情记录" name="detailRecord"></TabPane>-->
                    </Tabs>
                    <Tabs type="card" @on-click="changeDataDetailsIndex" :value="params.teaName" v-if="proKey=='4'">
                        <TabPane label="教师使用智能PC的场景详情" name="notAddTime"></TabPane>
                        <TabPane label="教师具体使用智能PC详情" name="isAddTime"></TabPane>
                        <!--<TabPane label="教师使用产品详情记录" name="detailRecord"></TabPane>-->
                    </Tabs>
                </div>
                <!--搜索框-->
                <div class="input-data">
                    <Input
                        v-if="teaUseScreenIndex==-1"
                        v-model="keyWord"
                        placeholder="支持场景编码、行为编码关键字搜索"
                        icon="ios-search"
                        clearable
                        @on-enter="handleSearch"
                    >
                        <Button
                            slot="append"
                            icon="ios-search"
                            class="search-input-button"
                            @click="handleSearch"
                            type="primary"
                        ></Button>
                    </Input>
                    <!--活跃教师具体使用详情（带时间）展示的搜索框-->
                    <Input
                        v-if="teaUseScreenIndex==1"
                        v-model="keyWord"
                        placeholder="支持场景编码、行为编码、创建时间关键字搜索"
                        icon="ios-search"
                        clearable
                        @on-enter="handleSearch"
                    >
                        <Button
                            slot="append"
                            icon="ios-search"
                            class="search-input-button"
                            @click="handleSearch"
                            type="primary"
                        ></Button>
                    </Input>
                </div>
            </div>
            <div>
                <!--活跃教师具体使用详情（不带时间）-->
                <div class="table-wrapper-data" v-if="teaUseScreenIndex==-1">
                    <Table :columns="activeTeaUseDetailsColumn" :data="activeTeaUseNotAddTimeList"></Table>
                </div>
                <!--活跃教师具体使用详情（带时间）-->
                <div class="table-wrapper-data" v-if="teaUseScreenIndex==1">
                    <Table :columns="activeTeaUseAddTimeColumn" :data="activeTeaUseAddTimeList"></Table>
                </div>
                <div class="table-wrapper-data" v-if="teaUseScreenIndex==2">
                    <div class="dt-course-video-info-list">
                        <div class="dt-course-video-main">
                            <div class="dt-course-video-main-title">
                                <Avatar :src="userHeadImg" style="background: #619fe7;margin-right: 10px;float:left;"
                                        size="large"></Avatar>
                                <p style="padding-top: 10px;">教师{{activeTeaUseRecord[0].fullName}}</p>
                            </div>
                            <div class="dt-course-video-main-content">
                                <Timeline class="dt-course-video-main-timeline">
                                    <Scroll :on-reach-bottom="handleReachBottom" :height="recordHeight">
                                        <TimelineItem class="dt-course-video-main-timeline-item"
                                                      v-for="item in activeTeaUseRecord" :key="item.rowNum">
                                            <i class="dt-course-video-main-timeline-item-icon" slot="dot"></i>
                                            <div class="dt-course-video-main-timeline-item-time">
                                                {{item.create_time.split(' ')[0].substring(5)+"-"+item.create_time.split(' ')[1]}}
                                            </div>
                                            <div class="dt-course-video-main-timeline-item-box">
                                                <span class="dt-course-video-main-timeline-item-box-left-arrow"></span>
                                                <div class="dt-course-video-main-timeline-item-box-info">
                                                    <div class="dt-course-video-main-timeline-item-box-info-content">
                  <span class="dt-course-video-main-timeline-item-box-info-content-explan"
                        v-if="item.dynamic_data.length>0">
                    <span
                        class="dt-course-video-main-timeline-item-box-info-content-module-name">{{item.funcName}}</span>
                    •使用{{item.clsName}}•{{item.dynamic_data}}
                  </span>
                                                        <span class="dt-course-video-main-timeline-item-box-info-content-explan"
                                                              v-else>
                    <span
                        class="dt-course-video-main-timeline-item-box-info-content-module-name">{{item.funcName}}</span>
                    •使用{{item.clsName}}
                  </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </TimelineItem>
                                    </Scroll>
                                </Timeline>
                            </div>
                        </div>
                    </div>
                </div>
                <!--分页,大屏重复绑定情况下不显示-->
                <div class="laypage_main" v-if="teaUseScreenIndex!=2">
                    <Page
                        :total="total"
                        :current="page"
                        :page-size="limit"
                        @on-change="handleCurrentChange"
                        v-show="total && pageCount>1"
                        show-total
                    />
                </div>
            </div>
        </card>
    </div>
</template>
<script>
    import {getTeacherCodingKeyList, getSchoolTeacherByIdList,} from "../../../../service/api.js";
    import dateSelect from "../../../../components/dateSelect.vue";
    import {mapGetters} from 'vuex'

    export default {
        name: "active-tea-details",
        computed: {
            ...mapGetters([
                'userHeadImg'
            ])
        },
        data () {
            return {
                params: {
                    schoolId: this.$route.query.schoolId,//学校id
                    startTime: this.$route.query.selfStartDate,//表格数据页面选择的开始时间
                    endTime: this.$route.query.selfEndDate,//表格数据页面选择的结束时间
                    seleMainStartDate: this.$route.query.parentalStartDate,//主页面的开始时间
                    seleMainEndDate: this.$route.query.parentalEndDate,//主页面的结束时间
                    curStartDate: '',//记住表格数据页面选择的开始时间
                    curEndDate: '',//记住表格数据页面选择的结束时间
                    userId: this.$route.query.userId,
                    schoolName: this.$route.query.schoolName,
                    tabsName: this.$route.query.tabsName,//tab名称
                    isShowRemind: this.$route.query.isShowRemind,//是否显示重复绑定
                    teaName: this.$route.query.teaName,//是否显示重复绑定
                    sourceType: this.$route.query.sourceType,//是否显示重复绑定
                    routerName: this.$route.query.routerName//路由名称
                },
                recordHeight:"0px",
                keyWord: "",
                page: 1,
                limit: 10,
                total: 0,//数据数量
                pageCount: 0,//页数
                teaUseScreenIndex: -1,//tab索引
                proKey: "-1",//默认展示全部产品使用详情
                activeTeaUseAddTimeList: [],//活跃教师使用详情（带时间）
                activeTeaUseNotAddTimeList: [],//活跃教师使用详情（不带时间）
                activeTeaUseRecord:[],//活跃教师使用详情记录
                activeTeaUseDetailsColumn: [
                    {
                        title: "序号",
                        key: "rowNum",
                        align: "center"
                    },
                    {
                        title: "用户名称",
                        key: "fullName",
                        align: "center"
                    },
                    {
                        title: "场景编码",
                        key: "funcName",
                        align: "center"
                    },
                    {
                        title: "行为编码",
                        key: "clsName",
                        align: "center"
                    },
                    {
                        title: "次数",
                        key: "count",
                        align: "center",
                    }
                ],
                activeTeaUseAddTimeColumn: [
                    {
                        title: "序号",
                        key: "rowNum",
                        align: "center"
                    },
                    {
                        title: "用户名称",
                        key: "fullName",
                        align: "center"
                    },
                    {
                        title: "场景编码",
                        key: "funcName",
                        align: "center"
                    },
                    {
                        title: "行为编码",
                        key: "clsName",
                        align: "center"
                    },
                    {
                        title: "动态数据",
                        key: "dynamic_data",
                        align: "center",
                    },
                    {
                        title: "创建时间",
                        key: "create_time",
                        align: "center",
                    }
                ],
                proList: [
                    {
                        value: "-1",
                        label: '全部'
                    },
                    {
                        value: "1",
                        label: '大屏'
                    },
                    {
                        value: "2",
                        label: '移动授课助手'
                    },
                    {
                        value: "3",
                        label: '备课助手'
                    },
                    {
                        value: "4",
                        label: '智能PC'
                    }
                ],
            }
        },
        components: {
            //时间选择组件
            dateSelect
        },
        methods: {
            /**
             * 返回上一页
             */
            gotoBack () {
                if (this.params.sourceType == 0) {
                    //如果是从表格tab页跳转进来，则带参返回表格tab页
                    this.$router.push({
                        name: "dataDetailsTab",
                        query: {
                            schoolId: this.params.schoolId,
                            parentalStartDate: this.params.curStartDate,
                            parentalEndDate: this.params.curEndDate,
                            curSeleMainStartDate: this.params.seleMainStartDate,
                            curSeleMainEndDate: this.params.seleMainEndDate,
                            schoolName: this.params.schoolName,
                            tabsName: this.params.tabsName,
                            isShowRemind: this.params.isShowRemind,
                            type: 1
                        }
                    });
                } else if (this.params.sourceType == 1) {
                    //如果是从主页面跳转进来，则带参返回主页面
                    this.$router.push({
                        name: this.params.routerName,
                        query: {
                            schoolId: this.params.schoolId,
                            startDate: this.params.curStartDate,
                            endDate: this.params.curEndDate,
                            schoolName: this.params.schoolName,
                        }
                    })
                } else {
                    //如果是从活跃教师top详情页面跳转，则返回活跃教师top10详情页面
                    this.$router.push({
                        name: "activeTeaTopDetails",
                        query: {
                            schoolId: this.params.schoolId,
                            parentalStartDate: this.params.curStartDate,
                            parentalEndDate: this.params.curEndDate,
                            schoolName: this.params.schoolName,
                            routerName: this.params.routerName,
                            curSeleMainStartDate: this.params.seleMainStartDate,
                            curSeleMainEndDate: this.params.seleMainEndDate,
                            type: 1
                        }
                    })
                }
            },
            /**
             * 点击tab切换数据信息
             */
            changeDataDetailsIndex (teaName) {
                //初始化参数
                this.keyWord = "";
                this.page = 1;
                this.total = 0;
                this.params.teaName = teaName;
                this.activeTeaUseRecord=[];
                if (teaName == 'notAddTime') {
                    //显示活跃教师具体使用详情（不带时间）
                    this.teaUseScreenIndex = -1;
                    this.queryActiveTeaUseNotAddTime();
                } else if (teaName == 'isAddTime') {
                    //显示活跃教师具体使用详情（带时间）
                    this.teaUseScreenIndex = 1;
                    this.queryActiveTeaUseAddTime();
                }else if (teaName == 'detailRecord') {
                    //显示活跃教师具体使用详情记录
                    this.teaUseScreenIndex = 2;
                    this.queryActiveTeaUseRecord();
                }
            },
            /**
             *翻页
             */
            handleCurrentChange (val) {
                this.page = val;
                if (this.teaUseScreenIndex == -1) {
                    //获取活跃教师具体使用详情（不带时间）
                    this.queryActiveTeaUseNotAddTime();
                } else if (this.teaUseScreenIndex == 1) {
                    //获取活跃教师具体使用详情（带时间）
                    this.queryActiveTeaUseAddTime();
                }
            },
            /**
             * 更新开始时间结束时间
             */
            updateDateTime (startDate, endDate) {
                this.page = 1;
                this.params.startTime = startDate;
                this.params.endTime = endDate;
                this.activeTeaUseRecord=[];
                if (this.teaUseScreenIndex == -1) {
                    //获取活跃教师具体使用详情（不带时间）
                    this.queryActiveTeaUseNotAddTime();
                } else if (this.teaUseScreenIndex == 1) {
                    //获取活跃教师具体使用详情（带时间）
                    this.queryActiveTeaUseAddTime();
                }else if (this.teaUseScreenIndex == 2) {
                    //获取活跃教师使用详情的记录
                    this.queryActiveTeaUseRecord();
                }
            },
            /**
             *搜索关键字
             */
            handleSearch () {
                this.total = 0;
                this.page = 1;
                if (this.teaUseScreenIndex == -1) {
                    //获取活跃教师具体使用详情（不带时间）
                    this.queryActiveTeaUseNotAddTime();
                } else if (this.teaUseScreenIndex == 1) {
                    //获取活跃教师具体使用详情（带时间）
                    this.queryActiveTeaUseAddTime();
                }
            },
            /**
             *获取活跃教师使用详情（不带时间）
             */
            async queryActiveTeaUseNotAddTime () {
                let _this = this;
                let params = {
                    schoolId: _this.params.schoolId,
                    startTime: _this.params.startTime,
                    endTime: _this.params.endTime,
                    userId: _this.params.userId,
                    proKey: _this.proKey,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await getTeacherCodingKeyList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.activeTeaUseNotAddTimeList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             *获取活跃教师使用详情（带时间）
             */
            async queryActiveTeaUseAddTime () {
                let _this = this;
                let params = {
                    schoolId: _this.params.schoolId,
                    startTime: _this.params.startTime,
                    endTime: _this.params.endTime,
                    userId: _this.params.userId,
                    proKey: _this.proKey,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await getSchoolTeacherByIdList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.activeTeaUseAddTimeList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             *获取活跃教师使用详情的记录
             */
            async queryActiveTeaUseRecord () {
                let _this = this;
                let params = {
                    schoolId: _this.params.schoolId,
                    startTime: _this.params.startTime,
                    endTime: _this.params.endTime,
                    userId: _this.params.userId,
                    proKey: _this.proKey,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await getSchoolTeacherByIdList(params)
                    .then(function (data) {
                        let resultDate = data.rows;
                        for (let i = 0; i < resultDate.length; i++) {
                            _this.activeTeaUseRecord.push(resultDate[i]);
                        }
                        _this.total = data.total_rows;
                        _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            handleReachBottom () {
                let _this = this;
                _this.page++;
                return new Promise(resolve => {
                    setTimeout(() => {
                        _this.queryActiveTeaUseRecord();
                        resolve();
                    }, 1000);
                });
            },
            /**
             *点击切换产品类型下拉框
             */
            onChange (val) {
                this.proKey = val;
                this.total = 0;
                this.page = 1;
                this.activeTeaUseRecord=[];
                //初始化tab页
                this.changeDataDetailsIndex(this.params.teaName);
            },
        },
        mounted () {
            let _this=this;
            //修改公共属性学校名称
            _this.$store.commit("SET_TOPHEADERNAME", _this.params.schoolName);
            _this.changeDataDetailsIndex(_this.params.teaName);
            _this.params.curStartDate = _this.params.startTime;
            _this.params.curEndDate = _this.params.endTime;
            _this.$refs.dateSelect.setDate(_this.params.curStartDate, _this.params.curEndDate);
            //计算高度
            _this.$nextTick(()=>{
                _this.recordHeight=window.innerHeight-250+'px';
            })
        }
    };
</script>
<style lang="scss" scoped>
    @import "../../../../style/home";
    @import "../../../../style/dataDetails";

    .dt-course-video-main-timeline-item-icon {
        background-image: url(../../../../assets/images/icon_timeline_big.png);
        background-size: 100% 100%;
    }

    .pro-download {
        float: left;
        margin-left: vw(50);
        height: vw(50);
        line-height: vw(50);

        span {
            font-size: 12px;
        }
    }

</style>
<style lang="scss">
    .tab-data-details {
        .ivu-input-group {
            width: 300px;
            float: right;
            top: 0;
        }

        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 355px;
        }

        .ivu-row {
            margin-top: 0 !important;
        }

        .ivu-card-body {
            padding: 16px;
        }

        .ivu-select {
            margin-left: 5px;
        }

        .ivu-input-large {
            height: 32px;
        }

        .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
            color: #fff;
            background: #57a3f3;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-btn-icon-only {
            border-radius: 0 4px 4px 0;
        }

        .ivu-input-icon-clear {
            margin-right: 45px;
        }

        .ivu-table {
            font-size: 14px;
        }

        .ivu-table-tip {
            overflow-x: hidden;
        }

        .ivu-tabs-nav {
            font-size: 14px;
        }
        .ivu-table-overflowX {
            overflow-x: hidden;
        }
    }
    .dt-course-video-main-timeline .ivu-timeline-item-tail {
        top: 38px !important;
        left: 8.5px !important;
    }

    .dt-course-video-main-timeline .ivu-timeline-item-head {
        width: 19px !important;
        height: 19px !important;
    }

    .dt-course-video-main-timeline .ivu-timeline-item-content {
        padding: 0 1px 10px 45px !important;
        font-size: 16px !important;
    }

    .dt-course-video-main-timeline .ivu-timeline-item {
        padding: 0 0 50px 0 !important;
        margin-left: 200px !important;
    }

    .dt-course-video-main-timeline .ivu-timeline-item-tail {
        border-left: 2px dashed #93d0f8 !important;
    }

    .dt-course-video-main-timeline .ivu-timeline-item-head-custom {
        left: 0 !important;
        margin-top: 43px !important;
    }

    .dt-course-video-main-timeline .ivu-timeline-item:last-child .ivu-timeline-item-tail {
        display: block !important;
    }
    .dt-course-video-info-list{
        ::-webkit-scrollbar {
            width: 0 !important;
        }
    }
</style>
